import {
  AutorenewOutlined,
  CalendarMonthOutlined,
  CancelOutlined,
  CheckCircleOutline,
  DateRangeOutlined,
  EventOutlined,
  MoneyOffOutlined,
  PaidOutlined,
  TuneOutlined,
  ViewAgendaOutlined,
} from "@mui/icons-material";
import type { SvgIconComponent } from "@mui/icons-material";
import { EJobStatuses } from "../../../../enum/job.enums";
import { colors } from "../../../../../ui/colors";
import type { BillingFilter, JobEventStatusFilter, TimeRangePreset } from "./job-event-filters.types";

/* ───── Generic option shape ───── */

export interface FilterOption<V extends string> {
  label: string;
  value: V;
  icon: SvgIconComponent;
}

/* ───── Color scheme (one per category) ───── */

export interface FilterColorScheme {
  activeBg: string;
  activeBorder: string;
  activeText: string;
  activeIcon: string;
  hoverBg: string;
  hoverBorder: string;
}

/* ───── Status ───── */

export const STATUS_FILTERS: readonly FilterOption<JobEventStatusFilter>[] = [
  { label: "All", value: "ALL", icon: ViewAgendaOutlined },
  { label: "Scheduled", value: EJobStatuses.SCHEDULED, icon: EventOutlined },
  { label: "In Progress", value: EJobStatuses.IN_PROGRESS, icon: AutorenewOutlined },
  { label: "Completed", value: EJobStatuses.COMPLETED, icon: CheckCircleOutline },
  { label: "Canceled", value: EJobStatuses.CANCELLED, icon: CancelOutlined },
];

export const STATUS_SCHEME: FilterColorScheme = {
  activeBg: colors.orange[100],
  activeBorder: colors.orange[200],
  activeText: colors.orange[700],
  activeIcon: colors.orange[500],
  hoverBg: colors.orange[50],
  hoverBorder: colors.orange[100],
};

/* ───── Time range ───── */

const CURRENT_MONTH = new Intl.DateTimeFormat("en-US", { month: "long" }).format(new Date());
// const NEXT_MONTH = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
//   new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
// );

export const TIME_FILTERS: readonly FilterOption<TimeRangePreset>[] = [
  { label: "This Week", value: "THIS_WEEK", icon: DateRangeOutlined },
  { label: `This ${CURRENT_MONTH}`, value: "THIS_MONTH", icon: CalendarMonthOutlined },
  // { label: `Next ${NEXT_MONTH}`, value: "NEXT_MONTH", icon: CalendarMonthOutlined },
  { label: "Custom", value: "CUSTOM", icon: TuneOutlined },
];

export const TIME_SCHEME: FilterColorScheme = {
  activeBg: colors.blue[50],
  activeBorder: colors.blue[200],
  activeText: colors.blue[700],
  activeIcon: colors.blue[500],
  hoverBg: colors.blue[50],
  hoverBorder: colors.blue[100],
};

/* ───── Billing / payment ───── */

export const BILLING_FILTERS: readonly FilterOption<BillingFilter>[] = [
  { label: "Not Paid", value: "NOT_PAID", icon: MoneyOffOutlined },
  { label: "Paid", value: "PAID", icon: PaidOutlined },
];

export const BILLING_SCHEME: FilterColorScheme = {
  activeBg: colors.success[50],
  activeBorder: colors.success[200],
  activeText: colors.success[700],
  activeIcon: colors.success[500],
  hoverBg: colors.success[50],
  hoverBorder: colors.success[100],
};
